import angular from 'angular';
import 'ng-file-upload';
import 'angular-bootstrap';
import 'angular-sanitize';
import 'ui-select';
import 'common/treeModule';
import './workersServices';

const workersControllers = angular.module('applicationModule.workersControllers', [
    'ngSanitize',
    'applicationModule.workersServices',
    'commonModule.treeModule',
    'ngFileUpload',
    'ui.bootstrap',
    'ui.select'
]);

//ExhibitorWorkersController
workersControllers.controller('WorkersController', ['$scope', '$rootScope', '$state', '$stateParams', 'NgTableParams', 'growl', 'Workers', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $state, $stateParams, NgTableParams, growl, Workers, AppsoupAPI, Permissions) {
    'use strict';
    const exhibitorId = $stateParams.exhibitorId;
    $scope.writeAccess = Permissions.hasWriteAccess('exhibitors');
    $scope.exhibitorId = exhibitorId;
    const appId = $stateParams.application_id;

    $scope.removeWorker = function (id) {
        Workers.remove(id)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    growl.success('MODULES.WORKERS.DELETE_WORKER');
                    $state.reload();
                } else {
                    growl.error('MODULES.WORKERS.ERROR_DELETE');
                }
            });
    };

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Workers.getWorkers(exhibitorId, appId, params._params)
                .then(function (response) {
                    params.total(response.data.workers.total);
                    params.count(response.data.workers.per_page);
                    params.page(response.data.workers.current_page);
                    return response.data.workers.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                    $scope.isFind = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });
}]);

workersControllers.controller('WorkerEditController', ['$scope', '$rootScope', '$state', '$stateParams', 'growl', 'Workers', function ($scope, $rootScope, $state, $stateParams, growl, Workers) {
    'use strict';
    const workerId = $stateParams.workerId;
    const appId = $stateParams.application_id;
    const exhibitorId = $stateParams.exhibitorId;
    $scope.editMode = false;
    $scope.imageRequired = true;
    $scope.worker = {};

    $scope.cancel = function () {
        $state.go('appsoup.application.workers', {'exhibitorId': exhibitorId});
    };

    if (angular.isDefined($stateParams.exhibitorId)) {
        $scope.editMode = true;
        Workers.get(workerId)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    $scope.fileUploadedLogo = true;
                    $scope.imageRequired = false;
                    $scope.worker = data['worker'];
                }
            })
            .catch(function () {
                $state.go('appsoup.application.workers', {'exhibitorId': exhibitorId}, growl.error('ERROR.EMPTY_DATA'));
            })
            .finally(function () {
                $rootScope.doingResolve = false;
            });
    }

    $scope.saveWorker = function () {
        const data = $scope.worker;
        data['app_id'] = appId;
        data['exhibitor_id'] = exhibitorId;
        Workers.save(data, $scope.uploadLogo, $scope.editMode, exhibitorId)
            .then(function (result) {
                let data = result.data;

                if (data.success) {
                    if ($scope.editMode) {
                        growl.success('MODULES.WORKERS.SUCCESS.EDIT');
                    } else {
                        growl.success('MODULES.WORKERS.SUCCESS.ADD');
                    }
                    $state.go('appsoup.application.workers', {'exhibitorId': exhibitorId});
                } else {
                    if (typeof data.error === 'object') {
                        $scope.formErrors = data.error;
                    } else {
                        if (data.error === "ERROR.FAILED_UPLOAD") {
                            $scope.imageRequired = true;
                            growl.error('MODULES.WORKERS.ERROR_UPLOAD');
                        } else {
                            growl.error('MODULES.WORKERS.ERRORS');
                        }
                    }
                }
            })
            .finally(function () {
                $scope.isLoading = false;
            });
    };

    $scope.inputErrors = {
        'first_name': [{type: '$invalid', msg: 'MODULES.WORKERS.ERROR.NAME'}],
        'last_name': [{type: '$invalid', msg: 'MODULES.WORKERS.ERROR.SURNAME'}],
        'email': [{error: 'pattern', msg: 'MODULES.WORKERS.ERROR.EMAIL_FORMAT'}, {
            error: 'required',
            msg: 'MODULES.WORKERS.ERROR.EMAIL'
        }],
        'phone': [{type: '$invalid', msg: 'MODULES.WORKERS.ERROR.PHONE'}],
        'link': [{error: 'pattern', msg: 'MODULES.WORKERS.ERROR.LINK_FORMAT'}, {
            error: 'required',
            msg: 'MODULES.WORKERS.ERROR.LINK'
        }]
    };
}]);

export default workersControllers;
